import { render, staticRenderFns } from "./DriverInstructions.vue?vue&type=template&id=c2154830&scoped=true&"
import script from "./DriverInstructions.vue?vue&type=script&lang=js&"
export * from "./DriverInstructions.vue?vue&type=script&lang=js&"
import style0 from "./DriverInstructions.vue?vue&type=style&index=0&id=c2154830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2154830",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2154830')) {
      api.createRecord('c2154830', component.options)
    } else {
      api.reload('c2154830', component.options)
    }
    module.hot.accept("./DriverInstructions.vue?vue&type=template&id=c2154830&scoped=true&", function () {
      api.rerender('c2154830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/DriverInstructions.vue"
export default component.exports